import * as types from './theme.actionsType';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  theme: 'theme-default',
  themes: [
    {
      title: 'Padrão',
      path: 'theme-default',
      url: system_routes.Common.Url + '/images/Themes/theme-default.jpg',
    },
    {
      title: 'Amarelo',
      path: 'theme-yellow',
      url: system_routes.Common.Url + '/images/Themes/theme-yellow.jpg',
    },
    {
      title: 'Azul',
      path: 'theme-blue',
      url: system_routes.Common.Url + '/images/Themes/theme-blue.jpg',
    },
    {
      title: 'Azul Claro',
      path: 'theme-lightblue',
      url: system_routes.Common.Url + '/images/Themes/theme-lightblue.jpg',
    },
    {
      title: 'Cinza',
      path: 'theme-gray',
      url: system_routes.Common.Url + '/images/Themes/theme-gray.jpg',
    },
    {
      title: 'Dourado',
      path: 'theme-gold',
      url: system_routes.Common.Url + '/images/Themes/theme-gold.jpg',
    },
    {
      title: 'Primavera',
      path: 'theme-spring',
      url: system_routes.Common.Url + '/images/Themes/theme-spring.jpg',
    },
    {
      title: 'Roxo',
      path: 'theme-purple',
      url: system_routes.Common.Url + '/images/Themes/theme-purple.jpg',
    },
    {
      title: 'Verde',
      path: 'theme-green',
      url: system_routes.Common.Url + '/images/Themes/theme-green.jpg',
    },
    {
      title: 'Vermelho',
      path: 'theme-red',
      url: system_routes.Common.Url + '/images/Themes/theme-red.jpg',
    },
    {
      title: 'Rosa',
      path: 'theme-pink',
      url: system_routes.Common.Url + '/images/Themes/theme-pink.jpg',
    },
  ],
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.LOAD_THEME:
      return state.merge({
        theme: action.payload,
      });
    default:
      return state;
  }
}

// selectors
export function getTheme(state) {
  return state.theme.theme;
}

export function getThemes(state) {
  return state.theme.themes;
}
